import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import TrendingDownOutlinedIcon from '@mui/icons-material/TrendingDownOutlined';
import { Flex, Text } from '@mantine/core';
import { rnd } from '../util';

export const PercentageChange = ({
  currentValue,
  previousValue,
}: {
  currentValue: number;
  previousValue: number;
}) => {
  const trend = rnd(
    ((currentValue - previousValue) / Math.abs(previousValue)) * 100,
  );

  const icon = (value: number) => {
    if (value === 0) {
      return null;
    }
    if (value > 0) {
      return <TrendingUpOutlinedIcon />;
    }
    return <TrendingDownOutlinedIcon />;
  };

  return (
    <Flex direction={'column'} justify={'flex-end'}>
      <Flex direction={'row'}>
        <Text
          style={{
            color: '#000',
            paddingRight: 4,
          }}
        >
          {trend}%
        </Text>
        {icon(trend)}
      </Flex>
    </Flex>
  );
};
